import { render, staticRenderFns } from "./cModalServicioSu.vue?vue&type=template&id=021b4023"
import script from "./cModalServicioSu.vue?vue&type=script&lang=js"
export * from "./cModalServicioSu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports